import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import Nav from '../components/Nav.jsx'
import Button from '../components/Button.jsx'
import TeamCarousel from '../components/TeamCarousel.jsx'

const Landing = () => {

  const team = {
    items: [
      {
        img: '/images/coralie.webp',
        user: "Coralie",
        text: "Créatrice et gérante de l'institut depuis Février 2017. Coralie est spécialisée dans le massage mais aussi dans l'épilation durable et le soin minceur."
      },
      {
        img: '/images/camille.webp',
        user: "Camille",
        text: "Esthéticienne au sein de l'institut depuis Septembre 2022 est désormais responsable adjointe, Camille est spécialisée en épilation définitive au laser et dans la beauté du regard."
      },
      {
        img: '/images/lilou.webp',
        user: "Lilou",
        text: "Apprentie en Brevet professionnel esthétique, Lilou développe ses connaissances en techniques esthétiques mais aussi en massage. Elle réalise aujourd’hui tous les soins demandés pour l’examen. Elle réalise aussi parfaitement et avec douceur les soins enfants."
      },
      {
        img: '/images/leonie.webp',
        user: "Léonie",
        text: "Esthéticienne au sein de l’institut depuis septembre 2023, Léonie est spécialisée dans la pose de vernis semi-permanent mais réalise aussi l’ensemble de nos soins esthétiques et massages."
      }
    ]
  };


  const book =
  {
    items: [
      {
        text: "Réserver",
        class: "bg-black text-white font-biryani text-sm py-2 px-4 rounded mt-3 smd:mr-3 xl:mt-10 xl:mr-8",
        link: "https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/352672"

      },
    ],
  }

  const knowMore =
  {
    items: [
      {
        text: "En savoir plus",
        class: "bg-white text-black font-biryani text-sm py-2 px-4 rounded mt-3 mb-5 xl:mt-10",
        link: "#"

      },
    ],
  }

  const whiteBook =
  {
    items: [
      {
        text: "Réserver",
        class: "bg-white text-black font-biryani text-sm py-2 px-1 sm:py-2 sm:px-4 rounded mt-3 mb-5 xl:mt-5 border-2 border-black ml-3 slg:mt-8 smd:ml-8 xl:ml-14",
        link: "https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/190085"

      },
    ],
  }

  const prestation =
  {
    items: [
      {
        text: "Voir tout",
        class: "bg-black text-white font-biryani text-sm py-2 px-1 sm:py-2 sm:px-4 rounded mt-3 mb-5 xl:mt-5 border-2 border-black ml-3 slg:mt-8 smd:ml-8 xl:ml-14",
        link: "https://www.kalendes.com/instantbienetrecoralie/#/link/PAGE/RESERVE"

      },
    ],
  }

  

  const scrollToElement = (elementId) => {
    let element = document.getElementById(elementId);
    if (element !== null) {
      element.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  };


  return (
    <div className="overflow-x-hidden">
      <Nav scroll={scrollToElement} />
    <header className=" relative bg-[#FDF5F1] h-[310px] slg:h-[370px] xl:h-[410px]">
      <div className='w-[43%] flex flex-col items-center ml-4 smd:w-1/2 smd:ml-[15%]'>
        <h1 className='text-black text-lg mt-5 font-bold font-crimson-text smd:mt-20 slg:text-3xl smd:text-2xl xl:text-4xl'>Découvrez notre SPA</h1>
        <p className='font-biryani text-black text-xs text-center mt-3 xl:text-base xl:mt-10'>
          Nous vous proposons 1h30 de détente pour 2, 3 ou 4 personnes. Un hammam,
          un sauna et une balnéo double sont à votre disposition selon vos envies. Envie de tester?
          Votre séance dans notre espace bien pourra être suivi d’un soin si vous le désirez.
        </p>
      </div>
      <div className='flex flex-col items-center ml-4 w-[43%] smd:w-1/2 smd:flex-row smd:justify-center smd:items-start smd:ml-[15%]'>
        <Button content={book} />
      </div>
        <img className='w-48 absolute top-10 right-0 slg:w-60 xl:w-72' src='/images/spatest.png' alt='SPA' />
    </header>

    <section className='relative'>
      <div>
        <h2 id='soins' className='text-black text-lg mt-14 font-bold font-crimson-text smd:mt-20 slg:text-3xl smd:text-2xl xl:text-4xl text-center slg:mt-28 xl:mt-40'>Découvrez nos soins expert</h2>
        <p className='font-biryani text-[#808080] text-sm text-center ml-3 mr-3 mt-3 xl:text-lg xl:mt-10 bxl:ml-[22rem] bxl:mr-[22rem]'>
            Nous vous proposons différents types de soins esthétiques tel
            que <a target='_blank' href='https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/190083'><span className='underline'>l'épilation</span></a>, les <a target='_blank' href='https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/190081'><span className='underline'>soins visage</span></a>, <a target='_blank' href='https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/190086'><span className='underline'>mains et pieds</span></a> et les <a target='_blank' href='https://www.kalendes.com/site/instantbienetrecoralie/link/ARTICLE/733182'><span className='underline'>soins minceur </span></a>
            mais nous vous proposons aussi:
        </p>
      </div>

      <div className='flex justify-center gap-4 mt-5 smd:gap-10 slg:gap14 xl:gap-20'>
        <div className='relative text-center'>
            <a target='_blank' href='https://www.kalendes.com/site/instantbienetrecoralie/link/ARTICLE/1987750'><img className='slg:w-60 xl:w-72 smd:w-40 w-28 hover:scale-110 transition-transform duration-200 ease-in-out cursor-pointer mb-3' src='/images/visage.png' alt='soins' /></a>
          <a target='_blank' href='https://www.kalendes.com/site/instantbienetrecoralie/link/ARTICLE/1987750'><span className='underline font-poppins text-sm text-[#808080] smd:text-base slg:text-lg xl:text-xl'>Aqua faciale</span></a>
          <img className='w-52 absolute top-[-110px] left-[-110px] hidden bxl:block' src='/images/flower3.png' alt='flower3' />
        </div>
        <div className='text-center'>
          <a target='_blank' href='https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/190080'><img className='slg:w-60 xl:w-72 smd:w-40 w-28 hover:scale-110 transition-transform duration-200 ease-in-out cursor-pointer mb-3' src='/images/lumiere.png' alt='soins' /></a>
          <a target='_blank' href='https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/190080'><span className='underline font-poppins text-sm text-[#808080] smd:text-base slg:text-lg xl:text-xl'>Épilation durable</span></a>
        </div>
        <div className='text-center'>
          <a target='_blank' href='https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/330594'><img className='slg:w-60 xl:w-72 smd:w-40 w-28 hover:scale-110 transition-transform duration-200 ease-in-out cursor-pointer mb-3' src='/images/enfant.png' alt='soins' /></a>
          <a target='_blank' href='https://www.kalendes.com/site/instantbienetrecoralie/link/FAMILLE/330594'><span className=' underline font-poppins text-sm text-[#808080] smd:text-base slg:text-lg xl:text-xl'>Soin enfants</span></a>
        </div>
      </div>

      <img className='w-52 absolute top-5 right-0 hidden bxl:block' src='/images/flower.png' alt='flower' />
    </section>
    
    <h2 id='massage' className='text-black text-lg mt-14 font-bold font-crimson-text slg:text-3xl smd:text-2xl xl:text-4xl text-center xl:mt-28'>Découvrez aussi nos massages du monde</h2>

    <section className='relative flex ml-3 mt-10 smd:ml-8 xl:ml-14'>
      <div>
        <img className='w-[600px]' src='/images/coralie_massageweb.png' alt='SPA' />
      </div>

      <div className='flex flex-col smd:justify-center'>
        <p className='font-biryani max-w-[40rem] xs:max-w-none mr-3 ml-3 text-[#808080] text-sm mt-3 mb-3 text-xs slg:text-lg slg:mt-10 slg:mb-10 smd:ml-8 xl:ml-14 smd:mr-8 xl:mr-14'>
            Spécialisée dans le massage depuis notre ouverture,
            nous vous proposons différents massages à venir découvrir.
            Nous nous formons régulièrement afin de vous apporter de la nouveauté.
            Nos massages sont aussi proposés en duo ou dans des rituels de soin.
        </p>

        <span className='ml-3 text-sm mb-2 smd:text-base slg:text-lg xl:text-xl smd:ml-8 xl:ml-14'>30min - 30€</span>
        <span className='ml-3 mb-2 text-sm smd:text-base slg:text-lg xl:text-xl smd:ml-8 xl:ml-14'>50min - 50€</span>
        <span className='ml-3 text-sm smd:text-base slg:text-lg xl:text-xl smd:ml-8 xl:ml-14'>80min - 80€</span>


        <div className='flex'>
          <Button content={whiteBook} />
        </div>
        
      </div>

      <img className='w-52 absolute top-80 right-0 hidden bxl:block' src='/images/flower2.png' alt='flower' />
    </section>

      <h2 id='team' className='text-black text-lg mt-14 font-bold font-crimson-text slg:text-3xl smd:text-2xl xl:text-4xl text-center xl:mt-32'>Notre équipe</h2>
      <TeamCarousel content={team} />

      <footer id='contact' className='bg-[#FDF5F1] mt-5 pt-3 pb-3'>
        <div className='ml-3 slg:flex slg:justify-around slg:ml-0'>
          <div>
            <h3 className='font-poppins font-medium smd:text-base slg:text-lg xl:text-xl mb-5'>Nos horaires</h3>
            <p className='font-biryani text-sm leading-6'>
              Lundi: 9h-20h<br/>
              Mardi: 9h-20h<br/>
              Mercredi: 9h-20h<br/>
              Jeudi: 9h-20h<br/>
              Vendredi: 9h-20h<br/>
              Samedi: 9h-18h<br/>
            </p>
          </div>

          <div>
            <h3 className='font-poppins font-medium smd:text-base slg:text-lg xl:text-xl mb-5 mt-3 slg:mt-0'>Instant bien être</h3>
            <p className='font-biryani text-sm'>
              <FontAwesomeIcon icon={faPhone} size='lg' /><span className='ml-2'>02 37 64 57 23</span>
            </p>

            <p className='font-biryani text-sm mt-2'>
              <FontAwesomeIcon icon={faEnvelope} size='lg' /><span className='ml-2'><a href="mailto:instantbienetretremblay@gmail.com">Email</a></span>
            </p>

            <p className='font-biryani text-sm mt-2'>
              <FontAwesomeIcon icon={faLocationDot} size='lg' /><span className='ml-2'>8 Rue du Dr Taugourdeau, 28170 Tremblay-les-Villages</span>
            </p>
            <p className='font-biryani text-sm mt-2'>
              <a href='/Mention-légales' target='_blank'>Mention légale</a>
            </p>
          </div>
        </div>

      </footer>
    </div>
  )
}

export default Landing